<div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [pagerVisible]="false" [(isBusyMessage)]="isBusyMessage"
        [columnDefs]="columnDefs" [requestInfo]="requestInfo" [gridContext]="gridContext"
        [responseArrayCallback]="responseArrayCallback" [responseCallback]="responseCallback" [showHeaderContextMenu]="false">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <div class='parent-header'>
            <span>Current License</span>
        </div>
    </ng-template>
</div>